<div class="u-margin-top-xl u-margin-bottom-l">
  <div class="c-section-title">
    <span class="c-section-title__text">{{ 'ALLOWANCES.DETAIL.CALCULATIONS.title' | translate }}</span>
    <span class="c-section-title__line"></span>
  </div>

  <!-- Desktop: Table view -->
  <div class="u-hide-mobile">
    <div class="table-responsive">
      <table class="c-datatable c-payments-details">
        <thead>
          <th class="c-datatable__header">{{ 'ALLOWANCES.DETAIL.CALCULATIONS.subtitle' | translate }}</th>
          <th class="c-datatable__header c-datatable__header--right">{{ 'ALLOWANCES.DETAIL.CALCULATIONS.amount_unemployment' | translate }}</th>
          <th class="c-datatable__header"></th>
          <th class="c-datatable__header c-datatable__header--right">{{ 'ALLOWANCES.DETAIL.CALCULATIONS.amount_BZ' | translate }}</th>
        </thead>

        <tbody>
          <tr class="c-datatable__row">
            <td class="c-datatable__cell">{{ 'ALLOWANCES.DETAIL.CALCULATIONS.payment' | translate }}</td>
            <td class="c-datatable__cell c-datatable__cell--highlight c-datatable__cell--right">
              <strong>{{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} {{ getFormattedNumber(totalCalculation.unemploymentGrossAmount) }}</strong>
            </td>
            <td class="c-datatable__cell"></td>
            <td class="c-datatable__cell c-datatable__cell--highlight c-datatable__cell--right">
              <strong>{{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} {{ getFormattedNumber(totalCalculation.additionalCompensationGrossAmount) }}</strong>
            </td>
          </tr>

          <tr class="c-datatable__row">
            <td class="c-datatable__cell">{{ 'ALLOWANCES.DETAIL.CALCULATIONS.withholding_tax' | translate }}</td>
            <td class="c-datatable__cell c-datatable__cell--highlight c-datatable__cell--right">
              {{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} -{{ getFormattedNumber(totalCalculation.unemploymentHoldingTax) }}
            </td>
            <td class="c-datatable__cell"></td>
            <td class="c-datatable__cell c-datatable__cell--highlight c-datatable__cell--right">
              {{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} -{{ getFormattedNumber(totalCalculation.additionalCompensationHoldingTax) }}
            </td>
          </tr>

          <!-- unionCreditors -->
          @for (unionCreditor of summaryItem?.unionCreditors; track unionCreditor) {
            <tr class="c-datatable__row">
              <td class="c-datatable__cell">
                <div>
                  <span>{{ 'ALLOWANCES.DETAIL.CALCULATIONS.recovery_abvv' | translate }}</span> -
                  <span>[{{unionCreditor?.natureOfDeduction}}]</span>
                  <span>({{unionCreditor?.c10Month}})</span>
                </div>
                <div class="u-text-xs u-text-gray-dark">
                  <span>{{unionCreditor?.internationalBankAccountNumber}}</span>
                </div>
              </td>
              <td class="c-datatable__cell c-datatable__cell--highlight c-datatable__cell--right">{{ getFormattedNumber(unionCreditor?.amountOfDeduction) }}</td>
              <td class="c-datatable__cell"></td>
              <td class="c-datatable__cell"></td>
            </tr>
          }

          <!-- externalCreditors -->
          @for (externalCreditor of summaryItem?.externalCreditors; track externalCreditor) {
            <tr class="c-datatable__row">
              <td class="c-datatable__cell">
                <div>
                  <span>{{ 'ALLOWANCES.DETAIL.CALCULATIONS.creditor_prepend' | translate }} - {{ externalCreditor?.creditorName }}</span> -
                  <span>{{ externalCreditor?.codeDebt }}({{ externalCreditor?.debtPaymentType }})</span>
                </div>
                <div class="u-text-xs u-text-gray-dark">
                  {{ externalCreditor?.internationalBankAccountNumber | ibanFormatter }}
                </div>
              </td>
              <td class="c-datatable__cell c-datatable__cell--highlight c-datatable__cell--right">
                {{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} -{{ getFormattedNumber(externalCreditor?.amountOfDeduction) }}
              </td>
              <td class="c-datatable__cell"></td>
              <td class="c-datatable__cell"></td>
            </tr>
          }

          <!-- membershipDeductions -->
          @for (membershipDeductionTransfer of summaryItem?.membershipDeductions; track membershipDeductionTransfer) {
            <tr class="c-datatable__row">
              <td class="c-datatable__cell">
                <div>{{ 'ALLOWANCES.DETAIL.CALCULATIONS.membership_fee' | translate }} - {{ getTranslatedData(membershipDeductionTransfer?.central) }}</div>
                <div class="u-text-xs u-text-gray-dark">{{ getTranslatedData(membershipDeductionTransfer?.contributionPaymentDescription) }}</div>
              </td>
              <td class="c-datatable__cell c-datatable__cell--highlight c-datatable__cell--right">
                <div>{{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} -{{ getFormattedNumber(calculateTotal(membershipDeductionTransfer?.amountOfContribution, membershipDeductionTransfer?.numberOfContributions)) }}</div>
                @if (membershipDeductionTransfer?.numberOfContributions > 1) {
                  <div class="u-text-xs u-text-gray-dark">
                    {{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} -{{ getFormattedNumber(membershipDeductionTransfer?.amountOfContribution) }} x {{ membershipDeductionTransfer?.numberOfContributions }}
                  </div>
                }
              </td>
              <td class="c-datatable__cell"></td>
              <td class="c-datatable__cell"></td>
            </tr>
          }

          <tr class="c-datatable__row c-datatable__row--total">
            <td class="c-datatable__cell">
              <div>{{ 'ALLOWANCES.DETAIL.CALCULATIONS.total' | translate }}</div>
              <div class="u-text-xs u-text-gray-dark">{{'ALLOWANCES.DETAIL.CALCULATIONS.deposit_on' | translate}} {{summaryItem?.internationalBankAccountNumber | ibanFormatter}}</div>
            </td>
            <td class="c-datatable__cell c-datatable__cell--highlight c-datatable__cell--right">
              <strong>{{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} {{ getFormattedNumber(totalCalculation.unemploymentNetAmount) }}</strong>
            </td>
            <td class="c-datatable__cell"></td>
            <td class="c-datatable__cell c-datatable__cell--highlight c-datatable__cell--right">
              <strong>{{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} {{ getFormattedNumber(totalCalculation.additionalCompensationNetAmount) }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Mobile: Card view -->
  <div class="u-show-mobile">
    <div class="c-calc-card">
      <!-- Gross amounts -->
      <div class="c-calc-card__row">
        <div class="c-calc-card__label">{{ 'ALLOWANCES.DETAIL.CALCULATIONS.payment' | translate }}</div>
        <div class="c-calc-card__amounts">
          <div class="c-calc-card__amount">
            <span class="c-calc-card__amount-label">{{ 'ALLOWANCES.DETAIL.CALCULATIONS.amount_unemployment' | translate }}</span>
            <strong>{{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} {{ getFormattedNumber(totalCalculation.unemploymentGrossAmount) }}</strong>
          </div>
          <div class="c-calc-card__amount">
            <span class="c-calc-card__amount-label">{{ 'ALLOWANCES.DETAIL.CALCULATIONS.amount_BZ' | translate }}</span>
            <strong>{{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} {{ getFormattedNumber(totalCalculation.additionalCompensationGrossAmount) }}</strong>
          </div>
        </div>
      </div>

      <!-- Withholding tax -->
      <div class="c-calc-card__row">
        <div class="c-calc-card__label">{{ 'ALLOWANCES.DETAIL.CALCULATIONS.withholding_tax' | translate }}</div>
        <div class="c-calc-card__amounts">
          <div class="c-calc-card__amount c-calc-card__amount--deduction">
            <span class="c-calc-card__amount-label">{{ 'ALLOWANCES.DETAIL.CALCULATIONS.amount_unemployment' | translate }}</span>
            {{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} -{{ getFormattedNumber(totalCalculation.unemploymentHoldingTax) }}
          </div>
          <div class="c-calc-card__amount c-calc-card__amount--deduction">
            <span class="c-calc-card__amount-label">{{ 'ALLOWANCES.DETAIL.CALCULATIONS.amount_BZ' | translate }}</span>
            {{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} -{{ getFormattedNumber(totalCalculation.additionalCompensationHoldingTax) }}
          </div>
        </div>
      </div>

      <!-- Union Creditors -->
      @for (unionCreditor of summaryItem?.unionCreditors; track unionCreditor) {
        <div class="c-calc-card__row">
          <div class="c-calc-card__label">
            {{ 'ALLOWANCES.DETAIL.CALCULATIONS.recovery_abvv' | translate }} - {{unionCreditor?.c10Month}}
            <div class="c-calc-card__sublabel">{{unionCreditor?.internationalBankAccountNumber}}</div>
          </div>
          <div class="c-calc-card__amounts">
            <div class="c-calc-card__amount c-calc-card__amount--deduction">
              {{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} -{{ getFormattedNumber(unionCreditor?.amountOfDeduction) }}
            </div>
          </div>
        </div>
      }

      <!-- External Creditors -->
      @for (externalCreditor of summaryItem?.externalCreditors; track externalCreditor) {
        <div class="c-calc-card__row">
          <div class="c-calc-card__label">
            {{ 'ALLOWANCES.DETAIL.CALCULATIONS.creditor_prepend' | translate }} - {{ externalCreditor?.creditorName }}
            <div class="c-calc-card__sublabel">{{ externalCreditor?.internationalBankAccountNumber | ibanFormatter }}</div>
          </div>
          <div class="c-calc-card__amounts">
            <div class="c-calc-card__amount c-calc-card__amount--deduction">
              {{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} -{{ getFormattedNumber(externalCreditor?.amountOfDeduction) }}
            </div>
          </div>
        </div>
      }

      <!-- Membership Deductions -->
      @for (membershipDeductionTransfer of summaryItem?.membershipDeductions; track membershipDeductionTransfer) {
        <div class="c-calc-card__row">
          <div class="c-calc-card__label">
            {{ 'ALLOWANCES.DETAIL.CALCULATIONS.membership_fee' | translate }} - {{ getTranslatedData(membershipDeductionTransfer?.central) }}
            <div class="c-calc-card__sublabel">{{ getTranslatedData(membershipDeductionTransfer?.contributionPaymentDescription) }}</div>
          </div>
          <div class="c-calc-card__amounts">
            <div class="c-calc-card__amount c-calc-card__amount--deduction">
              {{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} -{{ getFormattedNumber(calculateTotal(membershipDeductionTransfer?.amountOfContribution, membershipDeductionTransfer?.numberOfContributions)) }}
              @if (membershipDeductionTransfer?.numberOfContributions > 1) {
                <div class="c-calc-card__sublabel">
                  ({{ getFormattedNumber(membershipDeductionTransfer?.amountOfContribution) }} x {{ membershipDeductionTransfer?.numberOfContributions }})
                </div>
              }
            </div>
          </div>
        </div>
      }

      <!-- Total -->
      <div class="c-calc-card__row c-calc-card__row--total">
        <div class="c-calc-card__label">
          {{ 'ALLOWANCES.DETAIL.CALCULATIONS.total' | translate }}
          <div class="c-calc-card__sublabel">{{'ALLOWANCES.DETAIL.CALCULATIONS.deposit_on' | translate}} {{summaryItem?.internationalBankAccountNumber | ibanFormatter}}</div>
        </div>
        <div class="c-calc-card__amounts">
          <div class="c-calc-card__amount c-calc-card__amount--total">
            <span class="c-calc-card__amount-label">{{ 'ALLOWANCES.DETAIL.CALCULATIONS.amount_unemployment' | translate }}</span>
            <strong>{{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} {{ getFormattedNumber(totalCalculation.unemploymentNetAmount) }}</strong>
          </div>
          <div class="c-calc-card__amount c-calc-card__amount--total">
            <span class="c-calc-card__amount-label">{{ 'ALLOWANCES.DETAIL.CALCULATIONS.amount_BZ' | translate }}</span>
            <strong>{{ getCurrency(summaryItem?.paymentCalculations[0]?.unemploymentInfo?.currency) }} {{ getFormattedNumber(totalCalculation.additionalCompensationNetAmount) }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
